import { Paper, Theme, Typography } from "@yuno/design-system-web";
import SwipeableViews from "react-swipeable-views";
import { useIsTesting } from "@yuno/dashboard-container-mfe";
import styled from "@emotion/styled";
import { ToolsSidebarNav } from "./tools-sidebar-nav";
import { MenuItems } from "../../../types";
import { useState } from "react";
import { ToolsCheckout } from "./tools-checkout";
import { useTranslation } from "react-i18next";

const Container = styled(Paper)<{ isTesting?: boolean; theme?: Theme }>`
  width: 354px;
  height: ${({ isTesting }) => (isTesting ? "83.5vh" : "87.5vh")};
  border-radius: 0;
  border-left: 1px solid ${({ theme }) => theme.palette.grey[2]};
  padding-top: 20px;
  overflow-y: auto;
`;

const Title = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => theme.typography.small.regular};
  color: ${({ theme }) => theme.palette.neutral.black};
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[2]};
  padding-bottom: 20px;
  margin-bottom: 20px;
`;

export const ToolsSidebar = function () {
  const { isTesting } = useIsTesting();
  const [activeTools, setActiveTools] = useState<MenuItems | "">("");
  const { t } = useTranslation();

  const handleSelect = (menuItem: MenuItems) => {
    setActiveTools(menuItem);
  };

  return (
    <Container isTesting={isTesting}>
      <SwipeableViews
        containerStyle={{ height: "100%" }}
        index={activeTools === "CHECKOUT" ? 1 : 0}
        animateHeight
      >
        <section>
          <Title>{t("styles.customTitle")}</Title>
          <ToolsSidebarNav onSelect={handleSelect} />
        </section>
        <section>
          <ToolsCheckout onBack={setActiveTools.bind(null, 0)} />
        </section>
      </SwipeableViews>
    </Container>
  );
};
